import React from "react"

import { criteriaGradingRules, linkToFolder } from "../../Constants"
import { FormControl, FormControlLabel, FormHelperText, FormLabel, Input, Radio, RadioGroup, TextareaAutosize, Typography } from "@material-ui/core"
import CustomCardItem from "../../components/Cards/CustomCardItem"
import CustomBtn from "../../components/Buttons/CustomBtn"
import ConfirmDialog from "../../components/Dialogs/ConfirmDialog"
import CustomAlert from "../../components/CustomAlert"

const Attribution = ({ hasCoi, needsChanges, comment, coiText, observation, accepted, handleChange, grades, accessCode, saveDialog, handleClose, handleOpen, agree, onChange, inputError }) => {
    return (
        <>
            <CustomCardItem>
                <Typography variant="h3">Avaliação</Typography>
                {/* Alerta */}
                {inputError && <CustomAlert message={inputError} />}

                {/* Conflito de interesse ou não */}
                <FormControl component="fieldset">
                    <FormLabel component="legend">Declaro que possuo conflito de interesses para este trabalho</FormLabel>
                    <RadioGroup name="hasCoi" value={hasCoi} onChange={handleChange}>
                        <FormControlLabel value={"true"} control={<Radio />} label="Sim" />
                        <FormControlLabel value={"false"} control={<Radio />} label="Não" />
                    </RadioGroup>
                </FormControl>
                <br /><br />
                {
                    hasCoi != null &&
                    <>
                        {
                            hasCoi === 'true' ?
                                <>
                                    <TextareaAutosize
                                        maxRows={10}
                                        name="coiText"
                                        value={coiText}
                                        onChange={handleChange}
                                        required
                                        aria-describedby="coiText-helper"
                                    />
                                    <FormHelperText id={"coiText-helper"}>Descreva o conflito de interesse</FormHelperText>

                                </>
                                :
                                <>
                                    {/* Aceito ou não */}
                                    <FormControl component="fieldset">
                                        <FormLabel component="legend">Este trabalho cumpriu as normas do evento?</FormLabel>
                                        <RadioGroup name="accepted" value={accepted} onChange={handleChange}>
                                            <FormControlLabel value={"true"} control={<Radio />} label="Sim" />
                                            <FormControlLabel value={"false"} control={<Radio />} label="Não" />
                                        </RadioGroup>
                                    </FormControl>
                                    <br /><br />
                                    {
                                        accepted !== null &&
                                        <>
                                            {
                                                (accepted === 'true') ?
                                                    <div>
                                                        <FormControl component="fieldset">
                                                            <FormLabel component="legend">O trabalho necessita de alterações?</FormLabel>
                                                            <RadioGroup name="needsChanges" value={needsChanges} onChange={handleChange}>
                                                                <FormControlLabel value={"true"} control={<Radio />} label="Sim" />
                                                                <FormControlLabel value={"false"} control={<Radio />} label="Não" />
                                                            </RadioGroup>
                                                        </FormControl>
                                                        <CustomAlert severity='success' message="Para cada critério, mova a barra para a nota desejada" />
                                                        <CustomAlert severity='success' message="Ao movê-la, a nota será exibida abaixo da barra em vermelho" />
                                                        <CustomAlert severity='success' message="As notas vão de 0 a 10, com intervalos de 0.25" />
                                                        {
                                                            criteriaGradingRules.map((c, i) => (
                                                                <div key={i}>
                                                                    <Typography id={c.name + "-helper"}>{c.title}</Typography>
                                                                    <Input
                                                                        type="range"
                                                                        fullWidth
                                                                        name={c.name}
                                                                        value={grades[c.name] || ""}
                                                                        onChange={onChange}
                                                                        required
                                                                        aria-describedby={c.name + "-helper"}
                                                                        inputProps={{
                                                                            max: 10,
                                                                            step: 0.25,
                                                                            min: 0
                                                                        }}
                                                                    />
                                                                    <FormHelperText style={{ color: 'red' }}>Nota para {c.title}: {grades[c.name]}</FormHelperText>
                                                                    <hr />
                                                                </div>
                                                            ))
                                                        }

                                                        <TextareaAutosize
                                                            maxRows={10}
                                                            name="comment"
                                                            value={comment}
                                                            onChange={handleChange}
                                                            required
                                                            aria-describedby={"comment-helper"}
                                                        />
                                                        <FormHelperText id={"comment-helper"}>Comentário: parecer do aceite</FormHelperText>

                                                    </div>
                                                    :
                                                    <div>
                                                        <Typography>Caso o trabalho não cumpra as normas no evento, você deve preencher o campo abaixo</Typography>

                                                        <TextareaAutosize
                                                            maxRows={10}
                                                            name="observation"
                                                            value={observation}
                                                            onChange={handleChange}
                                                            required
                                                            aria-describedby={"observation-helper"}
                                                        />
                                                        <FormHelperText id={"observation-helper"}>Observação: descrição da recusa</FormHelperText>

                                                    </div>
                                            }
                                        </>
                                    }

                                </>
                        }
                        {
                            (accepted !== null || hasCoi !== null) &&
                            <>
                                <Input
                                    placeholder="Código do avaliador"
                                    fullWidth
                                    name="accessCode"
                                    type="password"
                                    value={accessCode}
                                    onChange={handleChange}
                                    required
                                    aria-describedby="accessCode-helper"
                                />
                                <FormHelperText id="accessCode-helper">Código de acesso</FormHelperText>

                                <CustomBtn fullWidth title="Submeter formulário" onClick={handleOpen} />
                            </>
                        }
                    </>
                }

            </CustomCardItem>
            <CustomCardItem>
                <Typography variant="h3">Dúvidas?</Typography>
                <Typography id="grade-helper">
                    <a href={linkToFolder} target="_blank" rel="noopener noreferrer">Verifique as normas aqui</a>
                </Typography>
            </CustomCardItem>
            <ConfirmDialog
                title="Submeter Avaliação?"
                message="ATENÇÃO: Esta ação é irreversível"
                open={saveDialog}
                agree={agree}
                handleClose={handleClose}
            />
        </>
    )
}

export default Attribution;
